import { isSsrDebugEnvironmentAllowed } from '@web-store-platforms/dev-tools';
import { getEnvVariable } from '@/lib/utils/env';
import { SSR_DEBUG_ALLOWED_ENVIRONMENTS } from '@/lib/utils/ssr-debug/ssr-debug.consts';
import { DEV_API_MOCK_COOKIE_VALUE } from './api-mock.consts';

export const isApiMockEnvironmentAllowed = (): boolean =>
    isSsrDebugEnvironmentAllowed(
        getEnvVariable('NEXT_PUBLIC_ENVIRONMENT') || getEnvVariable('REACT_APP_ENV'),
        SSR_DEBUG_ALLOWED_ENVIRONMENTS,
    );

export const shouldSkipShopPrefetch = (
    cookieValue: string | undefined,
    environment: string | undefined,
): boolean =>
    cookieValue === DEV_API_MOCK_COOKIE_VALUE &&
    isSsrDebugEnvironmentAllowed(environment, SSR_DEBUG_ALLOWED_ENVIRONMENTS);
